const SW_VERSION = "2026-08-26-1";

export function isWebPushSupported() {
  return (
    typeof window !== "undefined" &&
    "Notification" in window &&
    "serviceWorker" in navigator &&
    "PushManager" in window
  );
}

function base64UrlToUint8Array(base64Url) {
  const normalized = String(base64Url || "")
    .replace(/-/g, "+")
    .replace(/_/g, "/");
  const padding = "=".repeat((4 - (normalized.length % 4)) % 4);
  const raw = window.atob(normalized + padding);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) output[i] = raw.charCodeAt(i);
  return output;
}

export async function ensurePushServiceWorker() {
  const reg = await navigator.serviceWorker.register(`/sw.js?v=${SW_VERSION}`);
  await navigator.serviceWorker.ready;
  return reg;
}

export async function resolveVapidPublicKey(api, scope = "host") {
  try {
    const route = scope === "takofy" ? "/football/me/push/public-key" : "/host/notifications/push/public-key";
    const res = await api.get(route);
    const key = String(res?.data?.publicKey || "").trim();
    if (key) return key;
  } catch {
    // fallback to env key
  }

  const envKey = String(process.env.REACT_APP_VAPID_PUBLIC_KEY || "").trim();
  if (envKey) return envKey;
  throw new Error("VAPID public key bulunamadi.");
}

export async function getCurrentSubscription() {
  const reg = await ensurePushServiceWorker();
  return reg.pushManager.getSubscription();
}

export async function subscribeToHostPush(api, deviceName = "") {
  if (!isWebPushSupported()) {
    throw new Error("Tarayici push bildirimlerini desteklemiyor.");
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Bildirim izni verilmedi.");
  }

  const reg = await ensurePushServiceWorker();
  const existing = await reg.pushManager.getSubscription();
  if (existing) {
    await api.post("/host/notifications/push/subscriptions", {
      subscription: existing,
      deviceName,
    });
    return existing;
  }

  const publicKey = await resolveVapidPublicKey(api, "host");
  const subscription = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: base64UrlToUint8Array(publicKey),
  });

  await api.post("/host/notifications/push/subscriptions", {
    subscription,
    deviceName,
  });

  return subscription;
}

export async function unsubscribeFromHostPush(api) {
  if (!isWebPushSupported()) return;

  const reg = await ensurePushServiceWorker();
  const subscription = await reg.pushManager.getSubscription();
  if (!subscription) return;

  try {
    await api.delete("/host/notifications/push/subscriptions", {
      data: { endpoint: subscription.endpoint },
    });
  } catch {
    // backend endpoint yoksa local unsubscribe yine de yapilsin
  }

  await subscription.unsubscribe();
}

export async function getTakofyPushStatus(api) {
  if (!isWebPushSupported()) return { supported: false, active: 0 };
  const { data } = await api.get("/football/me/push/status");
  return { supported: true, ...data };
}

export async function subscribeToTakofyPush(api, deviceName = "") {
  if (!isWebPushSupported()) throw new Error("Tarayıcı push bildirimlerini desteklemiyor.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Bildirim izni verilmedi.");
  const reg = await ensurePushServiceWorker();
  let subscription = await reg.pushManager.getSubscription();
  if (!subscription) {
    const publicKey = await resolveVapidPublicKey(api, "takofy");
    subscription = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: base64UrlToUint8Array(publicKey) });
  }
  await api.post("/football/me/push/subscriptions", { subscription, deviceName });
  return subscription;
}

export async function unsubscribeFromTakofyPush(api) {
  if (!isWebPushSupported()) return;
  const reg = await ensurePushServiceWorker();
  const subscription = await reg.pushManager.getSubscription();
  if (!subscription) return;
  try { await api.delete("/football/me/push/subscriptions", { data: { endpoint: subscription.endpoint } }); } catch {}
  await subscription.unsubscribe();
}
